import { app } from '@microsoft/teams-js';

type EnsureInitialized = () => void;
export const ensureInitialized: EnsureInitialized = async () => {
  if (!app.isInitialized()) {
    await app.initialize();
  }
};
